package net.scalytica

package object blaargh {

  val CssSettings = scalacss.devOrProdDefaults

}



// WEBPACK FOOTER //
// /Users/kpm/Development/scalytica/renslebraten.no/_project/src/main/scala/net/scalytica/blaargh/package.scala